<template>
  <b-button
    variant="light"
    v-ifield-b-tooltip.hover
    v-bind:title="$t('appButtonReload.action.reload')"
    class="button-reload"
    v-on="$listeners"
  >
    <icon-reload class="icon" />
  </b-button>
</template>

<script>
import IconReload from '@/assets/ifield/ic_reload.svg?component'

/**
 * リロードボタン
 */
export default {
  name: 'AppButtonReload',
  components: {
    'icon-reload': IconReload,
  },
}
</script>

<style lang="scss" scoped>
.button-reload {
  @include mixin-button(true);
}
</style>
